import React from 'react';
import errorBoundary from '@ifeng/errorBoundary';
import { QQShare } from '@ifeng/three_terminal/es/mobile/qqShare/dynamic';

const SecondShare = () => {
    const qqShareConfig = {
        title: window.allData?.shareTitle,
        img: window.allData?.shareThumbnail,
        desc: window.allData?.introduction,
        appType: 'newsApp',
        cb: () => { },
    };

    return qqShareConfig?.title ? <QQShare content={qqShareConfig} /> : null;
};

export default errorBoundary(SecondShare);
